import { render, staticRenderFns } from "./InventoryLabResultCreate.vue?vue&type=template&id=6dbe764b"
import script from "./InventoryLabResultCreate.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbe764b')) {
      api.createRecord('6dbe764b', component.options)
    } else {
      api.reload('6dbe764b', component.options)
    }
    module.hot.accept("./InventoryLabResultCreate.vue?vue&type=template&id=6dbe764b", function () {
      api.rerender('6dbe764b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/InventoryLabResultCreate.vue"
export default component.exports